import CubesLoader from './cubes';
import CubesLoaderSmall from './cubesSmall';

export default { CubesLoader, CubesLoaderSmall };
